module.exports = __webpack_public_path__ + "static/img/pint.1127bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pint.png
// module id = hqq6
// module chunks = 0